import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import actions from "../actions"

class WCAuthorization extends Component {

    constructor(props) {
        super(props);
        let inviteId = null;
        if (props.location.search) {
            let queryString = new URLSearchParams(props.location.search);
            inviteId = queryString.get('data');
            if (inviteId || inviteId !== null) props.getInvitationDetails(inviteId);
        }

        this.state = {
            accessGranted: true,
            status: null,
            inviteId
        };

    }

    componentDidMount() {
        this.redirectRoute();
    }

    componentDidUpdate() {
        if (!this.state.accessGranted) {
            this.redirectRoute();
        }
    }

    static getDerivedStateFromProps(props, state) {
        const { location, isLogin, history } = props;
        const { pathname } = location;
        return {
            accessGranted: isLogin,
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextState.accessGranted !== this.state.accessGranted;
    }

    redirectRoute() {
        const { location, isLogin, history, openSocket } = this.props;
        const { pathname, search, state } = location;
        let redirectUrl = state && state.redirectUrl ? state.redirectUrl : "/";

        // Hide splashscreen
        document.getElementById("loading-contain").style.display = "none";
        if (!isLogin) {
            redirectUrl = pathname;
            if (pathname === "/") redirectUrl = "/SignIn"
            if (pathname === "/" && (this.state.inviteId || this.state.inviteId !== null)) redirectUrl = "Create-Account"

            history.push({
                pathname: redirectUrl,
                // pathname,
                search,
                state
            });
        }
        else {
            openSocket();
            redirectUrl = pathname === "/" || pathname === "/SignIn" || pathname === "/Welcome" || pathname === "/Create-Account" ? "/dashboard" : pathname
            history.push({
                pathname: redirectUrl,
                search,
                state
            });
        }
    }

    render() {
        return this.state.accessGranted || this.props.isLogin === false ? <React.Fragment>{this.props.children}</React.Fragment> : null;
    }
}

function mapStateToProps({ auth }) {
    return {
        isLogin: auth.isLogin
    }
}

const mapDispatch = (dispatch) => {
    return {
        getInvitationDetails: (request) => dispatch(actions.getInvitationDetails(request))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatch)(WCAuthorization));
